<template>
    <div class="grid grid-cols-2 sm:grid-cols-6 gap-3">
        <div class="tour-item">
            <a href="##" @click.prevent="toggleModal(true)">
                <div class="heading">
                    Add
                </div>
                <div class="content">
                    <i class="plus-large"></i>
                </div>
            </a>
        </div>
        <div v-for="tour in tours" :key="tour.identifier">
            <div v-if="tour.isVisible" class="tour-item">
                    <Link :href="route('tour.edit', tour.identifier)">
                    <div class="heading">
                        <div>{{ tour.title.localized_text[tour.fallback_language] }}</div>
                    </div>
                    <div v-if="userIsAdminOfThisToursProvider(tour.provider_id)" class="badge-buttons-wrapper">
                        <div class="badge-buttons">
                            <button @click.prevent="() => showTourDeleteConfirmationModal(tour.identifier)" title="Delete"><i class="trash"></i></button>
                        </div>
                    </div>
                    <div v-if="tour.image" class="content">
                        <img class="object-cover w-full h-full" :src="tour.image[0].first_file_path">
                    </div>
                </Link>
            </div>
        </div>
    </div>
    <Modal :showModal="showModal" :toggleModal="toggleModal" />
    <TourErrorModal :showModal="showErrorModal" :toggleModal="toggleErrorModal" />

    <TourDeleteConfirmationModal
        :showModal="tour_delete_form.showModal"
        :form="tour_delete_form"
        :hideModalFn="()=>{tour_delete_form.showModal = false; tour_delete_form.tour_identifier = null}"
    />

</template>

<script>

import { Link } from '@inertiajs/inertia-vue3';
import Modal from '@/RooomGuide/Modal';
import TourErrorModal from '@/Pages/Tour/Partials/TourErrorModal';
import TourDeleteConfirmationModal from '@/Pages/Tour/Partials/TourDeleteConfirmationModal';

export default {
    components: { Link, Modal, TourErrorModal, TourDeleteConfirmationModal },
    data() {
        return {
          tours: this.$page.props.tours.data,
          showModal: false,
          showErrorModal: false,
          tour_delete_form: this.$inertia.form({
            _method: 'DELETE',
            tour_identifier: null,
            showModal: false
           })
        }
    },
    mounted() {
        // small workaround for Search + Filter, see `Tour/Index.vue`
        this.tours.map(tour => { tour.isVisible = true; });
    },
    updated(){
        this.tours = this.$page.props.tours.data
        this.tours.map(tour => { tour.isVisible = true; });
    },
    methods:{
        toggleModal(value){
            if( this.$page.props.providers.data
                .filter(el => el.auth_user_role == 'admin').length == 0 )
            {
                this.toggleErrorModal(value)
            } else {
                this.showModal = value;
            }
        },
        toggleErrorModal(value){
            this.showErrorModal = value;
        },
        showTourDeleteConfirmationModal(tourIdentifier){
            this.tour_delete_form.tour_identifier = tourIdentifier;
            this.tour_delete_form.showModal = true;
        },
        userIsAdminOfThisToursProvider(providerId){

            const providersWithAdmin = this.$page.props.providers.data
            .filter(el => el.auth_user_role == 'admin');

            const idOfProviderWhichUserIsAdmin = providersWithAdmin.length && providersWithAdmin[0].id;
            if(providerId == idOfProviderWhichUserIsAdmin){
                return true
            } else{
                return false;
            }
        }
    }
}
</script>
